import styled from 'styled-components';
import { theme } from '@frameio/vapor';

export const MatchCardsContainer = styled.div`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces[1]};
  overflow: hidden;
  position: relative;
`;

export const MatchCard = styled.div`
  background: ${theme.colors.background.primary};
  cursor: pointer;
  padding: ${theme.spaces[12]};
  transition: background-color 0.2s ease;
  &:hover {
    background: ${theme.colors.background.secondary};
  }

  &:focus-visible {
    outline: ${theme.spaces[2]} solid ${theme.colors.border.interactive.focused};
    outline-offset: ${theme.spaces[2]};
  }
`;
